module.exports = __webpack_public_path__ + "static/media/account.7857b095.svg";